var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0835 9.99998C2.0835 6.26803 2.0835 4.40205 3.24286 3.24268C4.40224 2.08331 6.26821 2.08331 10.0002 2.08331C13.7321 2.08331 15.5981 2.08331 16.7575 3.24268C17.9168 4.40205 17.9168 6.26803 17.9168 9.99998C17.9168 13.7319 17.9168 15.5979 16.7575 16.7573C15.5981 17.9166 13.7321 17.9166 10.0002 17.9166C6.26821 17.9166 4.40224 17.9166 3.24286 16.7573C2.0835 15.5979 2.0835 13.7319 2.0835 9.99998Z",
    stroke: "#2E2C27",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 5.83331H14.1665",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 5.83331H6.66683",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 10H6.66683",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 14.1667H6.66683",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 10H14.1665",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 14.1667H14.1665",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadInfo);
export default __webpack_public_path__ + "static/media/lead-info.3e573df493aaab041007b614edf3595b.svg";
export { ForwardRef as ReactComponent };